import type { Course } from '@/types';

export const COURSES: Record<string, Course> = {
  chem2131: {
    id: 'chem2131',
    code: 'CHEM2131',
    name: 'CHEM2131',
    fullName: 'Analytical Chemistry Laboratory',
    description: 'Virtual laboratory experiments for Analytical Chemistry. Learn quantitative analysis techniques including spectrophotometry, titration, and gravimetric analysis.',
    experimentCount: 11,
    theme: 'chem2131',
  },
  chem1131: {
    id: 'chem1131',
    code: 'CHEM1131',
    name: 'CHEM1131',
    fullName: 'General Chemistry Laboratory',
    description: 'Introductory chemistry laboratory experiments covering qualitative analysis, stoichiometry, and fundamental reactions.',
    experimentCount: 11,
    theme: 'chem1131',
  },
};

export const COURSE_LIST = Object.values(COURSES);

export const AUTH_CONFIG = {
  passwords: {
    student: {
      chem2131: 'chem2131',
      chem1131: 'chem1131',
      default: 'student123',
    },
    instructor: {
      default: 'instructor2131',
    },
  },
};

// Experiment list metadata for each course
export const CHEM2131_EXPERIMENTS = [
  { id: 'exp1', number: 1, name: 'Emission Spectra', status: 'available' },
  { id: 'exp2', number: 2, name: 'Water Purification', status: 'available' },
  { id: 'exp3', number: 3, name: 'Phosphate in Cola', status: 'available' },
  { id: 'exp4', number: 4, name: 'EDTA Standardization', status: 'available' },
  { id: 'exp5', number: 5, name: 'Soaps & Detergents', status: 'available' },
  { id: 'exp6', number: 6, name: 'Vitamin C Analysis', status: 'available' },
  { id: 'exp7', number: 7, name: 'Gravimetric Analysis', status: 'available' },
  { id: 'exp8', number: 8, name: 'Nitrite Content', status: 'available' },
  { id: 'exp9', number: 9, name: 'Iron Determination', status: 'available' },
  { id: 'exp10', number: 10, name: 'Equilibrium', status: 'available' },
  { id: 'exp11', number: 11, name: 'Aspirin Determination', status: 'available' },
];

export const CHEM1131_EXPERIMENTS = [
  { id: 'exp1', number: 1, name: 'Household Compounds', status: 'available' },
  { id: 'exp2', number: 2, name: 'Cations Analysis', status: 'available' },
  { id: 'exp3', number: 3, name: 'Anions Analysis', status: 'available' },
  { id: 'exp4', number: 4, name: 'Molar Mass', status: 'available' },
  { id: 'exp5', number: 5, name: 'Copper Cycle', status: 'available' },
  { id: 'exp6', number: 6, name: 'Salts Formation', status: 'available' },
  { id: 'exp7', number: 7, name: 'Salts Solubility', status: 'available' },
  { id: 'exp8', number: 8, name: 'Aluminum Compound', status: 'available' },
  { id: 'exp9', number: 9, name: 'Acetic Acid Analysis', status: 'available' },
  { id: 'exp10', number: 10, name: 'Antacid Analysis', status: 'available' },
  { id: 'exp11', number: 11, name: 'Empirical Formula', status: 'available' },
];

export function getExperimentList(courseId: string) {
  switch (courseId) {
    case 'chem2131':
      return CHEM2131_EXPERIMENTS;
    case 'chem1131':
      return CHEM1131_EXPERIMENTS;
    default:
      return [];
  }
}
